import * as React from "react";
import "../style/history.css";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";

import { useState, useEffect } from "react";
import { baseURL } from "../config";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const Rulse = (props) => {
  const { dialog, setDialog } = props;

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setDialog(false);
  };

  useEffect(() => {
    setOpen(true);

    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    fetch(`${baseURL}gameHistory/result`, requestOptions)
      .then((response) => response.json())
      .then((res) => {
        setData(res.gameHistories);
      })
      .catch((error) => {
        console.error(error);
        setOpen(false);
      })
      .finally(() => {
        setOpen(false);
      });
  }, []);

  return (
    <Dialog
      fullScreen
      open={dialog}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        className: "rules-dialog",
      }}
    >
      <AppBar
        sx={{ position: "relative" }}
        className="rules-appbar"
      >
        <Toolbar>
          <Typography
            sx={{ ml: 1, flex: 1 }}
            variant="h6"
            component="div"
            className="rules-title"
          >
            <span className="rules-back">&lt;</span>
            Rules
          </Typography>

          <Button
            autoFocus
            color="inherit"
            onClick={handleClose}
            className="rules-close"
          >
            CLOSE
          </Button>
        </Toolbar>
      </AppBar>

      <div className="rules-page">

        {/* =========================
            HERO
        ========================= */}
        <div className="rules-hero">
          <div className="rules-hero-card">
            <div className="rules-hero-suits">
              <span>♠</span>
              <span>♥</span>
              <span>♦</span>
              <span>♣</span>
            </div>

            <h1>TEEN PATTI</h1>

            <p>
              Learn the game, understand the rankings,
              and play your best hand.
            </p>
          </div>
        </div>


        <div className="rules-show">

          {/* =========================
              QUICK INFO
          ========================= */}
          <div className="top-rules">

            <div className="rule-info-card">
              <div className="rule-icon">🎯</div>
              <div>
                <span>OBJECTIVE</span>
                <p>
                  Have the best three cards in your hand
                  and maximize the pot before the showdown.
                </p>
              </div>
            </div>

            <div className="rule-info-card">
              <div className="rule-icon">👥</div>
              <div>
                <span>NUMBER OF PLAYERS</span>
                <p>Unlimited Players</p>
              </div>
            </div>

            <div className="rule-info-card">
              <div className="rule-icon">🃏</div>
              <div>
                <span>NUMBER OF CARDS</span>
                <p>52 card deck</p>
              </div>
            </div>

            <div className="rule-info-card">
              <div className="rule-icon">♠</div>
              <div>
                <span>RANK OF CARDS</span>
                <p>A (High), K, Q, J, 10, 9, 8, 7, 6, 5, 4, 3, 2</p>
              </div>
            </div>

          </div>


          {/* =========================
              THE DEAL
          ========================= */}
          <div className="rules-section center-rules">

            <div className="section-title">
              <span className="section-card">A</span>

              <div>
                <h2>THE DEAL</h2>
                <small>TEEN PATTI</small>
              </div>
            </div>

            <div className="section-content">

              <h3>
                How Teen Patti is played
              </h3>

              <p>
                Teen Patti is a 3-card poker game for 3 to 6 players.
                The objective is to have the best 3-card hand and to
                place bets before the showdown.
              </p>

              <p>
                Each player in the game is given 3 cards face-down.
                Before the deal, a <strong>boot</strong> amount is
                agreed upon and collected from each player.
              </p>

              <p>
                This is the minimum stake put into the
                <strong> pot</strong> — the money kept in the center
                of the table.
              </p>

              <p>
                As the game progresses, the pot grows and is won by
                the winner of that hand. The winner is the player who
                remains in the game for the whole hand and has the
                highest or best hand.
              </p>

            </div>
          </div>


          {/* =========================
              HAND RANKINGS
          ========================= */}
          <div className="rules-section end-rules">

            <div className="section-title">
              <span className="section-card">♛</span>

              <div>
                <h2>RANKING OF HANDS</h2>
                <small>HIGHEST TO LOWEST</small>
              </div>
            </div>

            <h3 className="ranking-subtitle">
              Hands ranked from highest to lowest
            </h3>


            {/* TRAIL */}
            <div className="hand-card">
              <div className="playing-card black">
                <span>♠</span>
                <b>A</b>
              </div>

              <div className="hand-details">
                <h3>Trail</h3>
                <small>Three of a Kind / Set / Trio</small>

                <p>
                  Three cards of the same rank.
                  Aces are the highest, twos are the lowest.
                </p>
              </div>

              <div className="rank-number">01</div>
            </div>


            {/* PURE SEQUENCE */}
            <div className="hand-card">
              <div className="playing-card red">
                <span>♥</span>
                <b>A</b>
              </div>

              <div className="hand-details">
                <h3>Pure Sequence</h3>
                <small>Straight Flush / Run</small>

                <p>
                  Three consecutive cards within the same suit.
                  For example, A-K-Q of diamonds.
                </p>
              </div>

              <div className="rank-number">02</div>
            </div>


            {/* SEQUENCE */}
            <div className="hand-card">
              <div className="playing-card red">
                <span>♦</span>
                <b>K</b>
              </div>

              <div className="hand-details">
                <h3>Sequence</h3>
                <small>Straight / Normal Run</small>

                <p>
                  Three consecutive cards not within the same suit.
                </p>
              </div>

              <div className="rank-number">03</div>
            </div>


            {/* COLOR */}
            <div className="hand-card">
              <div className="playing-card black">
                <span>♣</span>
                <b>Q</b>
              </div>

              <div className="hand-details">
                <h3>Color</h3>
                <small>Flush / Colous</small>

                <p>
                  Three cards in the same suit but not in sequence.
                  When comparing two colors, compare the highest
                  value card, then the next, and so on.
                  The highest color is A-K-J and the lowest is 5-3-2.
                </p>
              </div>

              <div className="rank-number">04</div>
            </div>


            {/* PAIR */}
            <div className="hand-card">
              <div className="playing-card red">
                <span>♥</span>
                <b>K</b>
              </div>

              <div className="hand-details">
                <h3>Pair</h3>
                <small>Two of a Kind</small>

                <p>
                  Two cards that are the same rank.
                  If the pair is equal, the highest oddball card wins.
                  A-A-K is the highest pair and 2-2-3 is the lowest.
                </p>
              </div>

              <div className="rank-number">05</div>
            </div>


            {/* HIGH CARD */}
            <div className="hand-card">
              <div className="playing-card black">
                <span>♠</span>
                <b>A</b>
              </div>

              <div className="hand-details">
                <h3>High Card</h3>
                <small>Highest individual card</small>

                <p>
                  If the three cards do not fit in the above categories,
                  compare the highest card first, then second and so on.
                  The best hand is A-K-J with mixed suits and the lowest
                  is 5-3-2.
                </p>
              </div>

              <div className="rank-number">06</div>
            </div>

          </div>

        </div>
      </div>
    </Dialog>
  );
};

export default Rulse;
